import Button, { type ButtonVariant } from "../Button";

interface ButtonProps {
  label: string;
  link: string;
  buttonVariant: ButtonVariant
}

export default function Purchase({ label, link, buttonVariant }: ButtonProps) {
  return (
    <div className="z-20 mt-3 mb-8">
      <Button
        link={link}
        utm_term="landing-hero"
        useRefLink={true}
        variant={buttonVariant}
      >
        {label}
      </Button>
    </div>
  );
}
